import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  showLoader = false;
  saved = false;
  saving = false;
  error = false;

  private savingFinished = new Subject<boolean>();

  constructor() {}

  isSaved() {
    const self = this;
    setTimeout(function() {
      self.saving = false;
      self.error = false;
      self.saved = true;
      self.savingFinished.next(true);
    }, 0);
  }

  isLoading() {
    const self = this;
    setTimeout(function() {
      self.showLoader = true;
      self.saved = false;
      self.error = false;
      self.saving = true;
      self.savingFinished.next(false);
    }, 0);
  }

  savingFailed() {
    const self = this;
    if (this.saving) {
      setTimeout(function() {
        self.showLoader = true;
        self.saving = false;
        self.error = true;
        self.savingFinished.next(true);
      }, 0);
    }
  }

  clear() {
    const self = this;
    setTimeout(function() {
      self.showLoader = false;
      self.saved = false;
      self.saving = false;
      self.error = false;
      self.savingFinished.next(false);
    }, 0);
  }

  public getIsSaving(): boolean {
    return this.saving;
  }

  public getSavingFinishedSubscribable(): Observable<boolean> {
    return this.savingFinished;
  }
}
